// extracted by mini-css-extract-plugin
export var billingWrapper = "BillingPeriods-module--billingWrapper--489ed";
export var label = "BillingPeriods-module--label--f3dc4";
export var switchRoot = "BillingPeriods-module--switchRoot--12a53";
export var switchRootCheckedBusiness = "BillingPeriods-module--switchRootCheckedBusiness--7d322";
export var switchRootCheckedStarter = "BillingPeriods-module--switchRootCheckedStarter--cf9f5";
export var switchRootCheckedTeam = "BillingPeriods-module--switchRootCheckedTeam--ab852";
export var switchThumb = "BillingPeriods-module--switchThumb--644e3";